import { VRM } from '@motorway/mw-highway-code/alpha';
import { InfoBox } from '@motorway/mw-highway-code/alpha';

import { AgentsBoxCard, useReport, useVehicle, REPORT_OUTCOMES } from '@motorway/motorway-handshake-components';

import { Header } from '../../components/Header/Header';
import { Logo } from '../../components/Logo/Logo';
import { snowplowCtaClick } from '../../helpers/snowplow';

import styles from './End.module.scss';

export const End = () => {
  const { vehicle } = useVehicle();
  const { report } = useReport();

  const { inspection } = report;
  const { outcome } = inspection;
  const { enquiry } = vehicle;

  const INFO_BOXES: Partial<Record<typeof outcome, { content: string; heading: string }>> = {
    [REPORT_OUTCOMES.ADJUSTMENT]: {
      content: 'The dealer must submit a price adjustment form within 24 hours.',
      heading: 'Price adjustment form required',
    },
    [REPORT_OUTCOMES.CANCELLATION]: {
      content: 'The dealer must submit a cancellation form within 24 hours.',
      heading: 'Cancellation form required',
    },
  };

  const infoBox = INFO_BOXES[outcome];
  const { content, heading } = infoBox ?? {};

  return (
    <div className={styles.component}>
      <Logo noMargin />
      <Header>
        <div className={styles.vrm}>
          <VRM size="small" text={enquiry.vehicleDetails.prettyVrm} />
        </div>
        <h1>Collection completed</h1>
        <p>Thank you for using Motorway.</p>
      </Header>
      {
        infoBox && (
          <div className={styles.infoBox}>
            <InfoBox
              {...{ content, heading }}
              variant="info"
            />
          </div>
        )
      }
      <AgentsBoxCard clickCallback={snowplowCtaClick} />
    </div>
  );
};
